function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1045-1303H875v3409h-1920z"
}), React.createElement("path", {
  d: "M-1045-1006H875v3079h-1920z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M130.225 102.167a1.026 1.026 0 0 1 0 2.05c-8.022 0-15.897 3.293-21.606 9.034a1.023 1.023 0 0 1-1.45.004 1.025 1.025 0 0 1-.004-1.45c6.091-6.125 14.496-9.638 23.06-9.638zm-21.383-.95c.317.47.193 1.107-.276 1.424A38.422 38.422 0 0 0 98.114 113.1a1.025 1.025 0 1 1-1.702-1.144 40.473 40.473 0 0 1 11.006-11.014 1.025 1.025 0 0 1 1.424.275zM85.955 64.954c3.046 2.45 4.723 5.725 4.723 9.224 0 3.235-1.433 6.277-4.055 8.653l-.285.252v3.656c.72.098 1.439.213 2.153.344C97.021 88.647 103.694 92.4 105 92.4c.447 0 3.585-1.119 6.854-2.293l1.052-.378c2.814-1.01 5.522-1.977 6.492-2.223l.1-.024 1.976-.405V85.27c-2.802-2.41-4.34-5.555-4.34-8.904 0-3.5 1.678-6.776 4.724-9.225.375-.301.91-.301 1.284 0 3.046 2.45 4.724 5.725 4.724 9.225 0 3.164-1.372 6.144-3.885 8.496l-.456.409v1.472a48.156 48.156 0 0 1 6.7-.469 1.026 1.026 0 0 1 0 2.05c-2.256 0-4.494.17-6.7.497v.105l-.39-.045a46.2 46.2 0 0 0-2.407.445c-10.775 2.288-20.54 8.395-27.286 17.191a.97.97 0 0 1-.102.132 45.73 45.73 0 0 0-2.137 3.058l-.496.795-1.563 2.56a1.025 1.025 0 0 1-1.807-.963l.057-.105 1.562-2.56a47.865 47.865 0 0 1 2.015-3.034 30.01 30.01 0 0 0-11.196-2.165 1.026 1.026 0 0 1 0-2.05c4.293 0 8.485.847 12.474 2.52a48.461 48.461 0 0 1 4.36-4.827c-5.262-2.553-11.053-3.897-16.834-3.897a1.026 1.026 0 0 1 0-2.051c6.353 0 12.718 1.54 18.446 4.458a48.405 48.405 0 0 1 4.843-3.761 46.248 46.248 0 0 0-23.289-6.285 1.025 1.025 0 1 1 0-2.051c1.21 0 2.415.046 3.614.136l.898.076v-3.42c-2.802-2.411-4.34-5.555-4.34-8.905 0-3.5 1.677-6.775 4.723-9.224.375-.302.91-.302 1.285 0zm44.27 28.959a1.025 1.025 0 1 1 0 2.05c-4.351 0-8.658.744-12.802 2.21a1.025 1.025 0 1 1-.684-1.933 40.326 40.326 0 0 1 13.486-2.327zm-7.725-24.62c-2.144 1.973-3.315 4.457-3.315 7.073 0 1.981.673 3.888 1.932 5.554l.358.449v-6.823a1.026 1.026 0 0 1 2.034-.185l.016.185v6.823c1.49-1.769 2.29-3.841 2.29-6.003 0-2.616-1.17-5.1-3.315-7.074zm-37.188-2.188c-2.144 1.974-3.314 4.458-3.314 7.073 0 2.048.718 4.016 2.06 5.722l.23.281v-6.823a1.026 1.026 0 0 1 2.044-.112l.006.112v6.823c1.489-1.768 2.29-3.84 2.29-6.003 0-2.615-1.171-5.1-3.316-7.073z"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 51.416,
  y: 138.719
}, "Teren wypasu /"), React.createElement("tspan", {
  x: 46.352,
  y: 158.719
}, "niepiel\u0119gnowane"), React.createElement("tspan", {
  x: 70.04,
  y: 178.719
}, "pastwisko")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/rangeland.1ae1c624.svg";
export { SvgComponent as ReactComponent };